import { User } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export async function fetchUser(id: number) {
  return await restFactory.get<User>(`/dj/api/v1/strapi_user/${id}/`);
}
